export default "__VITE_ASSET__CkD2HDiv__"